import { register } from '../../../JavaScript/Utils'
import Splide from "@splidejs/splide";
export const BlogLatestPost = (el: HTMLElement) => {
    const sliderContainerNew: HTMLElement|null = el.querySelector('.splide-wrapper') as HTMLElement

    const BlogLatestPost = new Splide(sliderContainerNew, {
      perPage: 4,
      pagination: false,
      arrows: false,
      gap: 16,
      breakpoints: {
        1023: {
          type: 'loop',
          autoWidth: true,
          arrows: true,
          focus: 'center',
          perPage: 1,
        },
      }
    })

    BlogLatestPost.mount()
}

register('BlogLatestPost', BlogLatestPost)
